import { first } from 'lodash'
import { GeneralAPI } from '../../apis/GeneralAPI'
import LegalPage from '../../components/LegalPage'
import { buildLegalMeta, getLegalPageTitle } from '../../helpers/legalPages'

const pendingMessage =
    'The Service Level Agreement is being finalized and will be published here soon.'

export default function ServiceLevelAgreementPage(props) {
    return <LegalPage {...props} />
}

export async function getStaticProps() {
    const data = first(
        await GeneralAPI.getPageBySlug('service-level-agreement'),
    )
    const title = getLegalPageTitle(data, 'Service Level Agreement')

    const { meta, metaTitle } = buildLegalMeta({
        data,
        title,
        path: '/terms/service-level-agreement',
        description: data?.yoast_head_json?.description || pendingMessage,
    })

    return {
        props: {
            currentPath: '/terms/service-level-agreement',
            data: data || null,
            meta,
            metaTitle,
            pendingMessage: data ? null : pendingMessage,
            title,
        },
        revalidate: 10,
    }
}
